<template>
  <div>
    <div style="margin-top: 10px; margin-bottom: 10px; margin-left: 20px">
      <el-button @click="edit= {}, addDialogVisible = true">Add User</el-button>
    </div>
    <el-table :data="users" style="width: 100%">
      <el-table-column label="Name" width="300">
        <template slot-scope="scope">
          <p>{{ scope.row.fullName }}</p>
        </template>
      </el-table-column>
      <el-table-column label="E-Mail" width="400">
        <template slot-scope="scope">
          <p>{{ scope.row.email }}</p>
        </template>
      </el-table-column>
      <el-table-column label="Role" width="200">
        <template slot-scope="scope">
          <p>{{ scope.row.role }}</p>
        </template>
      </el-table-column>
      <el-table-column label="Operations">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">Edit</el-button>
          <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">Delete</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog :visible.sync="addDialogVisible" width="40%">
      <el-form ref="form" :model="edit" label-width="160px">
        <el-form-item label="Name">
          <el-input v-model="edit.fullName" />
        </el-form-item>
        <el-form-item label="E-Mail">
          <el-input v-model="edit.email" />
        </el-form-item>
        <el-form-item label="Role">
          <el-select v-model="edit.role" placeholder="Select">
            <el-option
              v-for="item in roles"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="Password"
          prop="password"
          :rules="[{ validator: validatePass, required: true }]"
        >
          <el-input type="password" v-model="edit.password"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelAddDialog(); ">Cancel</el-button>
        <el-button type="primary" @click="addUser()">Confirm</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { LoadUsers, AddUser, DeleteUser } from "../api.js";
import { validatePass } from "../lib/password-validation";

export default {
  name: "User",
  props: {},
  components: {},
  data: function() {
    return {
      addDialogVisible: false,
      users: [],
      form: {},
      edit: {},
      passwordDialogVisible: false,
      roles: [
        {
          value: "Admin",
          label: "Admin"
        },
        {
          value: "User",
          label: "User"
        }
      ],
      url: ""
    };
  },
  methods: {
    validatePass,
    handleEdit(index, user) {
      this.edit = user;
      this.addDialogVisible = true;
    },
    handleDelete(index, user) {
      DeleteUser(user);
      this.loadData();
    },
    async loadData() {
      this.users = await LoadUsers();
    },
    async addUser() {
      await AddUser(this.edit);
      this.addDialogVisible = false;

      this.loadData();
    },
    cancelAddDialog() {
      this.addDialogVisible = false;
    },
    async LoadUsers() {}
  },
  mounted() {
    this.loadData();
  }
};
</script>